import './styles.scss';

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import VisibilitySensor from 'react-visibility-sensor';
import ScrollableAnchor from 'react-scrollable-anchor';
import Well from 'Components/layout/Well';
import Input from 'Components/forms2/Input';
import ErrorMessage from 'Components/forms2/ErrorMessage';
import Head from 'Components/helpers/Head';
import Button from 'Components/layout/Button';
import ProgressPanel from 'Components/public/missionCostEstimation/ProgressPanel';
import IndustryForm from 'Components/public/missionCostEstimation/IndustryForm';
import Form from 'Components/forms2/Form';
import Textarea from 'Components/forms/Textarea';
import Checkbox from 'Components/forms/Checkbox';
import Select from 'Components/forms/SelectCustom';
import { sendMissionEstimation } from 'Redux/actions/enterprise';
import { Link } from 'react-router';
import countriesPhoneCode from 'Data/countries_phone_code.json';
import Recaptcha from 'react-recaptcha';

@connect(
    (state) => ({}), {
        sendMissionEstimation
    }
)
export default class MissionCostEstimation extends React.Component {
    static propTypes = {
        sendMissionEstimation: PropTypes.func.isRequired
    };
    static defaultProps = {};

    countriesPhoneCodeList = countriesPhoneCode.map(countryPhoneCode => {
        return { value: countryPhoneCode.code + '--' + countryPhoneCode.name, label: countryPhoneCode.code };
    });

    recaptchaRef = null;

    state = {
        progressPanelPosition: 0,
        lastSaveStatus: null,
        lastPublishStatus: null,
        isSavePending: false,
        isPublishPending: false,
        recaptchaError: false,
        captchaToken: '',
        errors: [],
        validationError: false,
        formState: {
            contentType: 'PHOTO',
            numberOfAssetsNeeded: 25,
            contentsPurpose: [],
            additionalServices: [],
            industry: '',
            country: '',
            email: '',
            firstName: '',
            lastName: '',
            companyName: '',
            phoneCode: '',
            phoneNumber:'',
            message: '',
            policyAcknowledgement: false,
            subscriptionAcknowledgement: false
        },
        sections: [{
            name: 'firstName',
            title: '1. First Name',
            valueTransform: state => state.firstName || 'None',
        }, {
            name: 'lastName',
            title: '2. Last Name',
            valueTransform: state => state.lastName || 'None',
        }, {
            name: 'companyName',
            title: '3. Company Name',
            valueTransform: state => state.companyName || 'None',
        },{
            name: 'email',
            title: '4. E-mail',
            valueTransform: state => state.email || 'None',
        },{
            name: 'phoneNumber',
            title: '5. Phone Number (optional)',
            valueTransform: state => state.phoneCode && state.phoneNumber ? (state.phoneCode.split("--")[0] + " - " +  state.phoneNumber) : 'None',
        }, {
            name: 'message',
            title: '6. Message',
            component: IndustryForm,
            valueTransform: state => state.message || 'None',
        }]
    };

    componentDidMount = () => {
      const script = document.createElement("script");
      script.src =
        "https://www.google.com/recaptcha/api.js";
      script.async = true;
      script.defer = true;
      document.body.appendChild(script);
        this.trackScroll();
        window.addEventListener('scroll', this.trackScroll);
    }

    componentWillUnmount = () => {
        window.removeEventListener('scroll', this.trackScroll);
    }

    setSectionVisibility = (name, state) => {
        return this.setState(prevState => {
            const sections = prevState.sections;
            const currentSectionIndex = sections.findIndex(section => section.name === name);
            sections[currentSectionIndex].isVisible = state;

            return {
                ...prevState,
                sections: sections
            };
        });
    }

    trackScroll = () => {
        const container = document.getElementsByClassName('container-mission-cost-estimation')[0];
        const progressPanel = document.getElementsByClassName('component-mission-cost-estimation-progress-panel')[0];

        if (container && progressPanel) {
            const containerHeight = container.offsetHeight;
            const progressPanelHeight = progressPanel.offsetHeight;

            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            const centerTopPos = scrollTop + ((window.innerHeight / 2) - (progressPanelHeight / 2));
            this.setState(prevState => ({
                progressPanelPosition: centerTopPos + progressPanelHeight + 96 > containerHeight ? containerHeight - progressPanelHeight - 172 : centerTopPos - 96 //-96 = negative padding
            }));

        }
    }

    onSave = () => {
        if (this.state.captchaToken === '') {
          this.setState({ recaptchaError: true });
          return;
        }
        const { formState } = this.state;

        return new Promise((resolve, reject) => {
            this.setState(prevState => ({
                ...prevState,
                validationError: false,
                errors: [],
                lastSaveStatus: null,
                isSavePending: true
            }), () => {
                this.props.sendMissionEstimation({
                    firstName: formState.firstName,
                    lastName: formState.lastName,
                    companyName: formState.companyName,
                    phoneNumber: formState.phoneNumber,
                    phoneCode: formState.phoneCode && formState.phoneCode.split('--')[0],
                    email: formState.email,
                    message: formState.message,
                    policyAcknowledgement: formState.policyAcknowledgement,
                    subscriptionAcknowledgement: formState.subscriptionAcknowledgement
                })
                    .then(response => {
                        if (response.state === 'SUCCESS' && response.payload.data.estimation.success) {
                            this.recaptchaRef.reset();
                            this.setState(prevState => ({
                                ...prevState,
                                lastSaveStatus: true,
                                isSavePending: false,
                                captchaToken: '',
                                formState: {
                                    ...prevState.formState,
                                    industry: '',
                                    country: '',
                                    email: '',
                                    firstName: '',
                                    lastName: '',
                                    companyName: '',
                                    phoneCode: '',
                                    phoneNumber:'',
                                    message: '',
                                    policyAcknowledgement: false,
                                    subscriptionAcknowledgement: false
                                }
                            }));
                            resolve(response);
                        } else {
                            throw response;
                        }

                    })
                    .catch(error => {
                        if (error.payload && error.payload.data && error.payload.data.estimation && Array.isArray(error.payload.data.estimation.errors)) {
                            this.setState(prevState => ({
                                ...prevState,
                                errors: error.payload.data.estimation.errors.filter(error => error.field && error.message),
                                validationError: true,
                                lastSaveStatus: false,
                                isSavePending: false
                            }));
                        } else {
                            this.setState(prevState => ({
                                ...prevState,
                                validationError: true,
                                lastSaveStatus: false,
                                isSavePending: false
                            }));
                        }

                        reject(error);
                    });
            });
        });
    }
    onFieldChange = (event) => {
        this.setState({
            ...this.state,
            formState: {
                ...this.state.formState,
                [event.name]: event.value
            }
        });
    }

    onChange = (name, value) => {
        this.setState({
            ...this.state,
            formState: {
                ...this.state.formState,
                [name]: value
            }
        });
    }

    render() {
        const { formState, sections, errors, isSavePending, isPublishPending, lastSaveStatus, progressPanelPosition, validationError, recaptchaError, captchaToken } = this.state;

        return (
            <div className="container-mission-cost-estimation">
                <Head
                    title={`Mission Cost Estimation`}
                    description={``}
                    robots={`noindex, nofollow`}
                    canonical={`/missions/cost-estimation`}
                />
                <div className="container-fluid">
                    <Form
                        data={formState}
                        errors={[]}
                        onSubmit={this.onSubmit}
                        isPending={isSavePending}
                    >
                        <div className="form-body">
                            <VisibilitySensor>
                                <ScrollableAnchor>
                                    <section className="form-section">
                                        <Well
                                            className="contact-form-well"
                                            title={'Contact Form'}
                                        >
                                            <div className='form'>
                                                <label>
                                                    <span>First Name</span>
                                                </label>
                                                <Input
                                                    name="firstName"
                                                    placeholder="Type your first name"
                                                    onChange={this.onFieldChange}
                                                    value={formState.firstName || ''}
                                                />
                                                {errors && errors.filter(error => error["field"] == "first_name")[0] && <ErrorMessage message={errors.filter(error => error["field"] == "first_name")[0]["message"]} />}
                                            </div>
                                            <div className='form'>
                                                <label>
                                                    <span>Last Name</span>
                                                </label>
                                                <Input
                                                    name="lastName"
                                                    placeholder="Type your last name"
                                                    onChange={this.onFieldChange}
                                                    value={formState.lastName || ''}
                                                />
                                                {errors && errors.filter(error => error["field"] == "last_name")[0] && <ErrorMessage message={errors.filter(error => error["field"] == "last_name")[0]["message"]} />}
                                            </div>
                                            <div className='form'>
                                                <label>
                                                    <span>Company Name</span>
                                                </label>
                                                <Input
                                                    name="companyName"
                                                    placeholder="Type your company name"
                                                    onChange={this.onFieldChange}
                                                    value={formState.companyName || ''}
                                                />
                                                {errors && errors.filter(error => error["field"] == "company_name")[0] && <ErrorMessage message={errors.filter(error => error["field"] == "company_name")[0]["message"]} />}
                                            </div>
                                    
                                            <div className='form'>
                                                <label>
                                                    <span>E-mail</span>
                                                </label>
                                                <Input
                                                    name="email"
                                                    placeholder="Type your email"
                                                    onChange={this.onFieldChange}
                                                    value={formState.email || ''}
                                                />
                                                {errors && errors.filter(error => error["field"] == "email")[0] && <ErrorMessage message={errors.filter(error => error["field"] == "email")[0]["message"]} />}
                                                {errors && errors.filter(error => error["field"] == "email_provider")[0] && <ErrorMessage message={errors.filter(error => error["field"] == "email_provider")[0]["message"]} />}
                                            </div>
                                            <div className='form'>
                                                <label>
                                                    <span>Phone Number (Optional)</span>
                                                </label>
                                                <div className='phone-field'>
                                                    <Select
                                                        itemDisplayName={""}
                                                        name="phoneCode"
                                                        className="items-per-page-select-options"
                                                        onChange={this.onChange}
                                                        placeholder="Phone Code"
                                                        value={formState.phoneCode || ''}
                                                        options={[
                                                            { value: '', label: "Select code", disabled: true },
                                                            ...this.countriesPhoneCodeList
                                                        ]}
                                                    />
                                                    <Input
                                                        className="number"
                                                        name="phoneNumber"
                                                        placeholder=""
                                                        value={formState.phoneNumber || ''}
                                                        onChange={this.onFieldChange}
                                                    />
                                                </div>
                                                {errors && errors.filter(error => error["field"] == "phone_number")[0] && <ErrorMessage message={errors.filter(error => error["field"] == "phone_number")[0]["message"]} />}
                                            </div>
                                            <div className='form'>
                                                <label>
                                                    <span>Message</span>
                                                </label>
                                                <Textarea
                                                    name="message"
                                                    placeholder="What can we help you with?"
                                                    value={formState.message}
                                                    onChange={this.onChange}
                                                />
                                            </div>
                                            
                                            <div className='checkbox'>
                                                {errors && errors.filter(error => error["field"] == "policy_acknowledgement")[0] && <ErrorMessage message={errors.filter(error => error["field"] == "policy_acknowledgement")[0]["message"]} />}
                                                <Checkbox
                                                    name="policyAcknowledgement"
                                                    value={formState.policyAcknowledgement}
                                                    label={<span>I consent to the processing of my personal data in order to answer my inquiry and acknowledge the <Link to={'/privacy-policy'} target="_blank">Privacy Policy</Link>.</span>}
                                                    onChange={this.onChange}
                                                />
                                                 
                                            </div>
                                            <div className='checkbox'>
                                                <Checkbox
                                                    name="subscriptionAcknowledgement"
                                                    value={formState.subscriptionAcknowledgement}
                                                    label={<span>I want to subscribe to the newsletter</span>}
                                                    onChange={this.onChange}
                                                />
                                            </div>
                                            <div className='form'>
                                              {recaptchaError && captchaToken === '' && <ErrorMessage message= 'Error verifying the captcha, Please try again' />}
                                              <Recaptcha
                                                ref={e => this.recaptchaRef =  e }
                                                sitekey={process.env.CAPTCHA_ID}
                                                render="explicit"
                                                onloadCallback={() => { console.log("done loading!");}}
                                                verifyCallback={(response) => this.setState({ captchaToken: response })}
                                              />
                                            </div>
                                            <Button
                                                styleType="primaryInvert"
                                                layout="full-width"
                                                onClick={this.onSave}
                                            >
                                                Send
                                            </Button>
                                            {validationError &&
                                                <p className="txt error">
                                                    There are some validation errors in you data. Please correct values and submit form again.
                                                </p>
                                            }
                                            {lastSaveStatus &&
                                                <p className="txt font-weight-bold">
                                                    Thank you very much! Our sales team will contact you in next 24h to discuss your project.
                                                </p>
                                            }
                                            <p className='txt'>Or contact us directly at sales@foap.com</p>
                                            <div className="image">
                                                <img className="member-avatar img-bottom-space" src={require('./images/contact-team-elad.jpg')} />
                                                <div className='img-txt'>
                                                    <p>Elad Matzliah</p>
                                                    <p>Head of Sales</p>
                                                </div>
                                            </div>
                                        </Well>
                                    </section>
                                </ScrollableAnchor>
                            </VisibilitySensor>
                        </div>
                        {/* <aside
                            style={{
                                top: `${progressPanelPosition}px`
                            }}
                        >
                            <ProgressPanel
                                ref="progressPanel"
                                showBrandHeader={false}
                                sections={sections}
                                state={formState}
                                onSave={this.onSave}
                                lastSaveStatus={lastSaveStatus}
                                isSavePending={isSavePending}
                                isPublishPending={isPublishPending}
                                validationError={validationError}
                            />
                        </aside> */}
                    </Form>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/containers/global/MissionCostEstimation/index.js